/* eslint-disable import/no-cycle */
import { isDromPostCode } from '../../ImportCommands/utils/checker';

/**
 * Validation de tout les formulaires présent
 * dans l'import de commande
 *
 * @param  {Object} values       valeur présente dans les formulaires
 * @return {Object}              Object contenant toute les erreurs pour la commande
 */
const validate = (values, props) => {
  const errors = { type: {} };
  const recipientErrors = {};
  const typeErrors = {};
  const recipientAddressErrors = {};
  const itemsArrayErrors = [];
  if (values.recipient) {
    if (!values.recipient.lastname) {
      recipientErrors.lastname = 'Champ requis';
    }
    if (!values.recipient.firstname) {
      recipientErrors.firstname = 'Champ requis';
    }
    if (!values.recipient.companyName && values.deliveryType === 'company') {
      recipientErrors.companyName = 'Champ requis';
    }
  }
  if (values.recipientAddress) {
    if (!values.recipientAddress.countryCode) {
      recipientAddressErrors.countryCode = 'Champ requis';
    } else if (
      values.recipientAddress.countryCode !== 'FR' &&
      values.deliveryType === 'pickupPoint'
    ) {
      errors.deliveryType =
        "L'envoi en point relais est diponible uniquement pour le France";
    }
    if (values.recipientAddress.countryCode) {
      if (
        values.recipientAddress.postalCode &&
        values.recipientAddress.countryCode === 'FR' &&
        isDromPostCode(values.recipientAddress.postalCode)
      ) {
        recipientAddressErrors.countryCode =
          'Pays incorrect par rapport au code postal';
      }
    }

    if (!values.recipientAddress.street) {
      recipientAddressErrors.street = 'Champ requis';
    }

    if (!values.recipientAddress.postalCode) {
      recipientAddressErrors.postalCode = 'Champ requis';
    } else if (values.recipientAddress.postalCode.length > 10) {
      recipientAddressErrors.postalCode = 'Champ trop long (Max. 10)';
    }

    if (!values.recipientAddress.city) {
      recipientAddressErrors.city = 'Champ requis';
    }
  }
  if (values.items) {
    values.items.forEach((item, itemIndex) => {
      const itemErrors = { customsDeclaration: {} };
      if (!item || !item.externalReference) {
        itemErrors.externalReference = 'Champ requis';
      }
      if ((!item || !item.ean13) && values.productIsInStock === 'inStock') {
        itemErrors.ean13 = 'Champ requis';
      }
      if (
        item.ean13 &&
        props.isStockHandled &&
        values.productIsInStock === 'inStock'
      ) {
        if (
          !props.productBarcode.filter(
            barcode => barcode.barcodeValue === item.ean13
          ).length > 0
        ) {
          itemErrors.ean13 = 'Code-barres inconnu';
        }
      }
      if (item.customsDeclaration) {
        if (!item.customsDeclaration.currency) {
          itemErrors.customsDeclaration.currency = 'Champ requis';
        }
        if (!item.customsDeclaration.declaredValue) {
          itemErrors.customsDeclaration.declaredValue = 'Champ requis';
        }
        if (item.customsDeclaration.declaredValue) {
          if (Number.isNaN(+item.customsDeclaration.declaredValue)) {
            itemErrors.declaredValue =
              'Valeur incorrect ( exemple de valeur correcte : 42.99 )';
          }
        }
        if (!item.customsDeclaration.objectType) {
          itemErrors.customsDeclaration.objectType = 'Champ requis';
        }
      }

      if (!item || !item.quantity) {
        itemErrors.quantity = 'Champ requis';
      }

      itemsArrayErrors[itemIndex] = itemErrors;
    });
  }

  if (values.type) {
    if (!values.type.width) {
      errors.type.width = 'Champ requis';
    }
    if (!values.type.height) {
      errors.type.height = 'Champ requis';
    }
    if (!values.type.length) {
      errors.type.length = 'Champ requis';
    }
    if (!values.type.weight) {
      errors.type.weight = 'Champ requis';
    } else if (
      values.deliveryType === 'pickupPoint' &&
      values.type.weight > 20
    ) {
      errors.type.weight =
        'Votre colis ne peut excéder 20 Kg pour un envoi en point relais';
    } else if (values.type.weight > 30) {
      errors.type.weight = 'Votre colis ne peut excéder 30 Kg';
    }
  } else {
    errors.type.width = 'Champ requis';
    errors.type.height = 'Champ requis';
    errors.type.length = 'Champ requis';
    errors.type.weight = 'Champ requis';
  }

  if (!values.deliveryType) {
    errors.deliveryType = 'Champ requis';
  }

  if (!values.externalReference) {
    errors.externalReference = 'Champ requis';
  }

  if (!values.productIsInStock) {
    errors.productIsInStock = 'Champ requis';
  }

  if (values.insuranceAmount > 30000) {
    errors.insuranceAmount =
      "Le coût maximal de l'assurance est de 30000 euros";
  }

  if (Object.keys(recipientErrors).length !== 0) {
    errors.recipient = recipientErrors;
  }
  if (Object.keys(typeErrors).length !== 0) {
    errors.type = typeErrors;
  }

  if (Object.keys(recipientAddressErrors).length !== 0) {
    errors.recipientAddress = recipientAddressErrors;
  }

  errors.items = itemsArrayErrors;
  return errors;
};

export default validate;
